"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GTranslate_exports = {};
__export(GTranslate_exports, {
  default: () => GTranslate_default
});
module.exports = __toCommonJS(GTranslate_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.4961 4.99609H9.66016L8.99609 2.75H4.50391C4.08724 2.75 3.72917 2.89974 3.42969 3.19922C3.14323 3.48568 3 3.83724 3 4.25391V14C3 14.4167 3.14323 14.7747 3.42969 15.0742C3.72917 15.3607 4.08724 15.5039 4.50391 15.5039H9.75781L10.5 17.75H16.4961C16.9128 17.75 17.2643 17.6068 17.5508 17.3203C17.8503 17.0208 18 16.6628 18 16.2461V6.5C18 6.08333 17.8503 5.73177 17.5508 5.44531C17.2643 5.14583 16.9128 4.99609 16.4961 4.99609ZM6.88672 12.1836C6.04036 12.1836 5.3112 11.8841 4.69922 11.2852C4.10026 10.6862 3.80078 9.96354 3.80078 9.11719C3.80078 8.27083 4.10026 7.54818 4.69922 6.94922C5.29818 6.35026 6.02734 6.05078 6.88672 6.05078C7.26432 6.05078 7.62891 6.1224 7.98047 6.26562C8.33203 6.39583 8.65104 6.59115 8.9375 6.85156L8.97656 6.91016L8.05859 7.78906L8.01953 7.75C7.91536 7.64583 7.76562 7.54818 7.57031 7.45703C7.38802 7.35286 7.16016 7.30078 6.88672 7.30078C6.39193 7.30078 5.96875 7.48307 5.61719 7.84766C5.26562 8.19922 5.08984 8.6224 5.08984 9.11719C5.08984 9.625 5.26562 10.0547 5.61719 10.4062C5.96875 10.7578 6.39193 10.9336 6.88672 10.9336C7.39453 10.9336 7.76562 10.8099 8 10.5625C8.2474 10.3021 8.40365 10.0612 8.46875 9.83984H6.80859V8.6875H9.77734V8.72656C9.79036 8.80469 9.79688 8.88281 9.79688 8.96094C9.8099 9.03906 9.81641 9.11719 9.81641 9.19531C9.81641 10.0807 9.54297 10.8034 8.99609 11.3633C8.44922 11.9102 7.74609 12.1836 6.88672 12.1836ZM11.3984 10.9141C11.5286 11.1354 11.6654 11.3568 11.8086 11.5781C11.9648 11.7865 12.1276 11.9883 12.2969 12.1836L11.8867 12.5742L11.3984 10.9141ZM11.9844 10.3477H11.2422L11.0078 9.56641H13.9961C13.9961 9.56641 13.9115 9.77474 13.7422 10.1914C13.5859 10.6081 13.2799 11.0833 12.8242 11.6172C12.6549 11.4219 12.4987 11.2201 12.3555 11.0117C12.2253 10.7904 12.1016 10.569 11.9844 10.3477ZM17.2578 16.2461C17.2578 16.4544 17.1797 16.6367 17.0234 16.793C16.8802 16.9362 16.7044 17.0078 16.4961 17.0078H11.2422L12.7461 15.5039L12.1406 13.4141L12.8242 12.7305L14.8359 14.7422L15.3828 14.1953L13.3516 12.1836C13.6901 11.806 13.9831 11.3958 14.2305 10.9531C14.4909 10.4974 14.6797 10.0352 14.7969 9.56641H15.7539V8.78516H13.0195V8.00391H12.2383V8.78516H10.7734L9.89453 5.75781H16.4961C16.7044 5.75781 16.8802 5.82943 17.0234 5.97266C17.1797 6.11589 17.2578 6.29167 17.2578 6.5V16.2461Z",
      fill: "currentColor"
    }
  )
);
const SvgGTranslate = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GTranslate_default = SvgGTranslate;
